import { gql } from "@apollo/client";

export default gql`
  query getAdminAnnouncements($input: ListChangelogInput){
    getAdminAnnouncements(input: $input){
        success
        data{
            docs{
                _id
                categoryId
                coverImageUrl
                channels
                status
                translations
                scheduledAt
                publishedAt
                sendStats
                reactionCount
                reactionAvg
                createdBy
                updatedBy
                createdAt
                updatedAt
                category{
                    _id
                    color
                    translations
                    createdAt
                    updatedAt
                }
                myReaction
                myReactionComment
            }
            hasNextPage
            totalDocs
        }
        error
        message
    }
}
`
